import { render, staticRenderFns } from "./AuthLogout.vue?vue&type=template&id=5d2e48ba&"
import script from "./AuthLogout.vue?vue&type=script&lang=js&"
export * from "./AuthLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2e48ba')) {
      api.createRecord('5d2e48ba', component.options)
    } else {
      api.reload('5d2e48ba', component.options)
    }
    module.hot.accept("./AuthLogout.vue?vue&type=template&id=5d2e48ba&", function () {
      api.rerender('5d2e48ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthLogout.vue"
export default component.exports